
import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';

const Contact = () => {
  return (
    <section id="contact" >
      <Container>
        <h2 className="text-center mb-4">Kontakt</h2>
        <Card className="text-center rounded">
          <Card.Body>
            <Row className="justify-content-center">
              <Col xs={12} md={3} className="mb-4">
                <div className="contact-info rounded">
                  <h5>Adres</h5>
                  <p>Nurska 9, Czyżew</p>
                </div>
              </Col>
              <Col xs={12} md={3} className="mb-4">
                <div className="contact-info">
                  <h5>Telefon</h5>
                  <p>+48 500 033 667</p>
                </div>
              </Col>
              <Col xs={12} md={3} className="mb-4">
                <div className="contact-info">
                  <h5>Email</h5>
                  <p>noclegiczyzew@wp.pl</p>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </section>
  );
};

export default Contact;
